import React from 'react';

import styled from 'styled-components';

import {getOptions} from 'app/general/dashboards/DashboardFilterbarStateFilter';
import {useSweetTeamDetail} from 'app/teams/slice';
import {gt} from 'app/utils/i18n';

import type {DashboardLocationParamsType} from 'app/documents/types';
import type {OptionValueType} from 'app/general/dashboards/DashboardFilterbarStateFilter';
import type {contentType} from 'app/utils/content-type';

type Props = {
  query: DashboardLocationParamsType;
  ct: contentType;
  resetFilters: () => void;
};

type DefaultFilterProps = {
  query?: string;
};

const BADGE_CLASSES = 'badge badge-info mx-1';

export const ResetFilterMessage = ({query, ct, resetFilters}: Props) => (
  <>
    <StyledBadgesContainerDiv>
      {query.search ? (
        <span className={BADGE_CLASSES}>
          <i className="fa fa-fw fa-search mr-1" />
          {query.search}
        </span>
      ) : null}
      <TagFilterMessage query={query.tag} />
      <TeamFilterMessage query={query.team_id} />
      <FilterFilterMessage query={query.filter} ct={ct} />
    </StyledBadgesContainerDiv>

    <span>
      <button
        className="btn-outline-primary btn btn-sm mt-3"
        onClick={resetFilters}
      >
        <i className="fa fa-times" /> {gt('Reset filters and view all')}
      </button>
    </span>
  </>
);

const TagFilterMessage = ({query}: DefaultFilterProps) => {
  if (query == null) {
    return null;
  }

  const tags = query?.split(',').map((item) => ({
    name: item,
  }));

  return (
    <>
      {tags.map((tag) => (
        <span key={tag.name} className={BADGE_CLASSES}>
          <i className="fa fa-fw fa-tag mr-1" />
          {tag.name}
        </span>
      ))}
    </>
  );
};

const TeamFilterMessage = ({query}: DefaultFilterProps) => {
  if (query == null) {
    return null;
  }

  const {team} = useSweetTeamDetail(query);

  return team ? (
    <span key={team.id} className={BADGE_CLASSES}>
      <i className="fa fa-fw fa-users mr-1" />
      {team.name}
    </span>
  ) : null;
};

const FilterFilterMessage = ({
  query,
  ct,
}: DefaultFilterProps & {
  ct: contentType;
}) => {
  if (query == null) {
    return null;
  }

  const filters = query.split(',');
  const options = getOptions(ct);
  const selectedFilters: Array<OptionValueType> = options.filter(
    (option) => filters.indexOf(option.value) > -1
  );

  return (
    <>
      {selectedFilters.map((selected) => (
        <span key={selected.value} className={BADGE_CLASSES}>
          {selected.label}
        </span>
      ))}
    </>
  );
};

// force badges font-size to default (even if they are inside 'lead' class)
const StyledBadgesContainerDiv = styled.div`
  font-size: 1rem;
`;
